// Datos de prueba para el módulo POS

// Transacciones de ejemplo
export const mockTransactions = [
  {
    id: 'TXN001',
    fecha: '2026-03-05',
    hora: '09:15',
    tipo: 'venta',
    concepto: 'Venta de productos',
    valor: 125.50,
    medioPago: 'Efectivo',
    cliente: 'Juan Pérez',
    proveedor: null,
    empleado: 'Maria García',
    estado: 'completada',
  },
  {
    id: 'TXN002',
    fecha: '2026-03-05',
    hora: '09:30',
    tipo: 'venta',
    concepto: 'Venta de servicios',
    valor: 250.00,
    medioPago: 'Tarjeta Débito',
    cliente: 'Ana López',
    proveedor: null,
    empleado: 'Carlos Rodríguez',
    estado: 'completada',
  },
  {
    id: 'TXN003',
    fecha: '2026-03-05',
    hora: '10:00',
    tipo: 'gasto',
    concept: 'Compra de suministros',
    valor: 45.00,
    medioPago: 'Efectivo',
    cliente: null,
    proveedor: 'Suministros El Salvador',
    empleado: 'Maria García',
    estado: 'completada',
  },
  {
    id: 'TXN004',
    fecha: '2026-03-05',
    hora: '10:30',
    tipo: 'pago',
    concepto: 'Pago a proveedor',
    valor: 500.00,
    medioPago: 'Transferencia',
    cliente: null,
    proveedor: 'Distribuidora ABC',
    empleado: 'Carlos Rodríguez',
    estado: 'completada',
  },
  {
    id: 'TXN005',
    fecha: '2026-03-05',
    hora: '11:00',
    tipo: 'cobro',
    concepto: 'Cobro CXC',
    valor: 180.00,
    medioPago: 'Efectivo',
    cliente: 'Roberto Sánchez',
    proveedor: null,
    empleado: 'Maria García',
    estado: 'completada',
  },
  {
    id: 'TXN006',
    fecha: '2026-03-05',
    hora: '11:30',
    tipo: 'venta',
    concepto: 'Venta de productos',
    valor: 89.99,
    medioPago: 'Tarjeta Crédito',
    cliente: 'Laura Martínez',
    proveedor: null,
    empleado: 'Ana Torres',
    estado: 'completada',
  },
  {
    id: 'TXN007',
    fecha: '2026-03-04',
    hora: '14:00',
    tipo: 'gasto',
    concepto: 'Mantenimiento equipos',
    valor: 150.00,
    medioPago: 'Cheque',
    cliente: null,
    proveedor: 'TechService',
    empleado: 'Carlos Rodríguez',
    estado: 'completada',
  },
  {
    id: 'TXN008',
    fecha: '2026-03-04',
    hora: '15:30',
    tipo: 'venta',
    concepto: 'Venta de productos',
    valor: 320.75,
    medioPago: 'Efectivo',
    cliente: 'Miguel Hernández',
    proveedor: null,
    empleado: 'Maria García',
    estado: 'completada',
  },
  {
    id: 'TXN009',
    fecha: '2026-03-04',
    hora: '16:00',
    tipo: 'cobro',
    concepto: 'Cobro CXC',
    valor: 250.00,
    medioPago: 'Transferencia',
    cliente: 'Empresa XYZ',
    proveedor: null,
    empleado: 'Ana Torres',
    estado: 'pendiente',
  },
  {
    id: 'TXN010',
    fecha: '2026-03-03',
    hora: '09:00',
    tipo: 'venta',
    concepto: 'Venta de servicios',
    valor: 450.00,
    medioPago: 'Tarjeta Débito',
    cliente: 'Pedro Gómez',
    proveedor: null,
    empleado: 'Carlos Rodríguez',
    estado: 'completada',
  },
  {
    id: 'TXN011',
    fecha: '2026-03-03',
    hora: '10:30',
    tipo: 'gasto',
    concepto: 'Alquiler local',
    valor: 800.00,
    medioPago: 'Transferencia',
    cliente: null,
    proveedor: 'Inmobiliaria SB',
    empleado: 'Admin',
    estado: 'completada',
  },
  {
    id: 'TXN012',
    fecha: '2026-03-02',
    hora: '11:00',
    tipo: 'venta',
    concepto: 'Venta de productos',
    valor: 67.50,
    medioPago: 'Efectivo',
    cliente: 'Sandra Rivera',
    proveedor: null,
    empleado: 'Maria García',
    estado: 'cancelada',
  },
];

// Cierres de turno de ejemplo
export const mockClosures = [
  {
    id: 'CIERRE001',
    fechaApertura: '2026-03-05',
    horaApertura: '08:00',
    fechaCierre: '2026-03-05',
    horaCierre: '14:00',
    responsable: 'Maria García',
    ingresos: 465.49,
    egresos: 45.00,
    total: 420.49,
    estado: 'cerrado',
  },
  {
    id: 'CIERRE002',
    fechaApertura: '2026-03-04',
    horaApertura: '08:00',
    fechaCierre: '2026-03-04',
    horaCierre: '18:00',
    responsable: 'Carlos Rodríguez',
    ingresos: 920.75,
    egresos: 950.00,
    total: -29.25,
    estado: 'cerrado',
  },
  {
    id: 'CIERRE003',
    fechaApertura: '2026-03-03',
    horaApertura: '08:00',
    fechaCierre: '2026-03-03',
    horaCierre: '17:00',
    responsable: 'Ana Torres',
    ingresos: 517.50,
    egresos: 800.00,
    total: -282.50,
    estado: 'cerrado',
  },
  {
    id: 'CIERRE004',
    fechaApertura: '2026-03-02',
    horaApertura: '09:00',
    fechaCierre: '2026-03-02',
    horaCierre: '15:00',
    responsable: 'Maria García',
    ingresos: 280.00,
    egresos: 120.00,
    total: 160.00,
    estado: 'cerrado',
  },
  {
    id: 'CIERRE005',
    fechaApertura: '2026-03-01',
    horaApertura: '08:00',
    fechaCierre: '2026-03-01',
    horaCierre: '18:00',
    responsable: 'Carlos Rodríguez',
    incomes: 1250.00,
    egresos: 300.00,
    total: 950.00,
    estado: 'cerrado',
  },
];

// Opciones para filtros
export const filterOptions = {
  tipoPago: [
    { value: 'efectivo', label: 'Efectivo' },
    { value: 'tarjeta_debito', label: 'Tarjeta Débito' },
    { value: 'tarjeta_credito', label: 'Tarjeta Crédito' },
    { value: 'transferencia', label: 'Transferencia' },
    { value: 'cheque', label: 'Cheque' },
  ],
  tipoTransaccion: [
    { value: 'venta', label: 'Venta' },
    { value: 'gasto', label: 'Gasto' },
    { value: 'pago', label: 'Pago' },
    { value: 'cobro', label: 'Cobro' },
  ],
  periodo: [
    { value: 'diario', label: 'Diario' },
    { value: 'semanal', label: 'Semanal' },
    { value: 'mensual', label: 'Mensual' },
    { value: 'anual', label: 'Anual' },
    { value: 'personalizado', label: 'Personalizado' },
  ],
  empleados: [
    { value: 'maria', label: 'Maria García' },
    { value: 'carlos', label: 'Carlos Rodríguez' },
    { value: 'ana', label: 'Ana Torres' },
    { value: 'admin', label: 'Admin' },
  ],
  clientes: [
    { value: 'juan', label: 'Juan Pérez' },
    { value: 'ana', label: 'Ana López' },
    { value: 'roberto', label: 'Roberto Sánchez' },
    { value: 'laura', label: 'Laura Martínez' },
    { value: 'miguel', label: 'Miguel Hernández' },
    { value: 'pedro', label: 'Pedro Gómez' },
    { value: 'sandra', label: 'Sandra Rivera' },
    { value: 'empresa', label: 'Empresa XYZ' },
  ],
  proveedores: [
    { value: 'suministros', label: 'Suministros El Salvador' },
    { value: 'distribuidora', label: 'Distribuidora ABC' },
    { value: 'techservice', label: 'TechService' },
    { value: 'inmobiliaria', label: 'Inmobiliaria SB' },
  ],
};

// Lista completa de proveedores para autocomplete
export const proveedoresList = [
  { id: 'PROV001', nombre: 'Suministros El Salvador', nit: '0614-010101-101-1', telefono: '2221-0000', direccion: 'San Salvador' },
  { id: 'PROV002', nombre: 'Distribuidora ABC', nit: '0614-020202-202-2', telefono: '2222-0000', direccion: 'Soyapango' },
  { id: 'PROV003', nombre: 'TechService', nit: '0614-030303-303-3', telefono: '2223-0000', direccion: 'San Salvador' },
  { id: 'PROV004', nombre: 'Inmobiliaria SB', nit: '0614-040404-404-4', telefono: '2224-0000', direccion: 'Santa Tecla' },
  { id: 'PROV005', nombre: 'Papelería Central', nit: '0614-050505-505-5', telefono: '2225-0000',direccion: 'San Salvador' },
  { id: 'PROV006', nombre: 'Servicios Eléctricos SA', nit: '0614-060606-606-6', telefono: '2226-0000', direccion: 'San Miguel' },
  { id: 'PROV007', nombre: 'Aqua Limpia', nit: '0614-070707-707-7', telefono: '2227-0000', direccion: 'San Salvador' },
  { id: 'PROV008', nombre: 'Seguridad Total', nit: '0614-080808-808-8', telefono: '2228-0000', direccion: 'Santa Tecla' },
];

// Lista completa de clientes para autocomplete
export const clientesList = [
  { id: 'CLI001', nombre: 'Juan Pérez', nit: '0614-111111-111-1', telefono: '7888-0001', direccion: 'San Salvador' },
  { id: 'CLI002', nombre: 'Ana López', nit: '0614-222222-222-2', telefono: '7888-0002', direccion: 'Santa Tecla' },
  { id: 'CLI003', nombre: 'Roberto Sánchez', nit: '0614-333333-333-3', telefono: '7888-0003', direccion: 'San Miguel' },
  { id: 'CLI004', nombre: 'Laura Martínez', nit: '0614-444444-444-4', telefono: '7888-0004', direccion: 'San Salvador' },
  { id: 'CLI005', nombre: 'Miguel Hernández', nit: '0614-555555-555-5', telefono: '7888-0005', direccion: 'Soyapango' },
  { id: 'CLI006', nombre: 'Pedro Gómez', nit: '0614-666666-666-6', telefono: '7888-0006', direccion: 'Santa Tecla' },
  { id: 'CLI007', nombre: 'Sandra Rivera', nit: '0614-777777-777-7', telefono: '7888-0007', direccion: 'San Salvador' },
  { id: 'CLI008', nombre: 'Empresa XYZ', nit: '0614-888888-888-8', telefono: '7888-0008', direccion: 'San Salvador' },
  { id: 'CLI009', nombre: 'Consumidor Final', nit: null, telefono: null, direccion: null },
];

// Lista de productos para autocomplete
export const productosList = [
  { id: 'PROD001', codigo: '001', nombre: 'Leche Entero 1L', precio: 1.50, existencia: 100, categoria: 'Lácteos' },
  { id: 'PROD002', codigo: '002', nombre: 'Pan Frances', precio: 0.75, existencia: 50, categoria: 'Panadería' },
  { id: 'PROD003', codigo: '003', nombre: 'Huevos Docena', precio: 3.50, existencia: 30, categoria: 'Huevos' },
  { id: 'PROD004', codigo: '004', nombre: 'Queso Blanco 500g', precio: 5.25, existencia: 20, categoria: 'Lácteos' },
  { id: 'PROD005', codigo: '005', nombre: 'Mantequilla 250g', precio: 4.00, existencia: 25, categoria: 'Lácteos' },
  { id: 'PROD006', codigo: '006', nombre: 'Yogurt Fresa', precio: 2.00, existencia: 40, categoria: 'Lácteos' },
  { id: 'PROD007', codigo: '007', nombre: 'Café molido 500g', precio: 8.50, existencia: 15, categoria: 'Bebidas' },
  { id: 'PROD008', codigo: '008', nombre: 'Azúcar 1kg', precio: 1.25, existencia: 60, categoria: 'Endulzantes' },
  { id: 'PROD009', codigo: '009', nombre: 'Arroz 1lb', precio: 0.85, existencia: 80, categoria: 'Granos' },
  { id: 'PROD010', codigo: '010', nombre: 'Frijoles 1lb', precio: 1.50, existencia: 70, categoria: 'Granos' },
  { id: 'PROD011', codigo: '011', nombre: 'Aceite Vegetal 1L', precio: 3.75, existencia: 35, categoria: 'Aceites' },
  { id: 'PROD012', codigo: '012', nombre: 'Jabón de Tocador', precio: 0.50, existencia: 100, categoria: 'Higiene' },
  { id: 'PROD013', codigo: '013', nombre: 'Shampoo 500ml', precio: 6.50, existencia: 25, categoria: 'Higiene' },
  { id: 'PROD014', codigo: '014', nombre: 'Pasta Dental', precio: 2.25, existencia: 40, categoria: 'Higiene' },
  { id: 'PROD015', codigo: '015', nombre: 'Cerveza Nacional 6pk', precio: 8.00, existencia: 20, categoria: 'Bebidas Alcohólicas' },
  { id: 'PROD016', codigo: '016', nombre: 'Refresco 600ml', precio: 0.85, existencia: 100, categoria: 'Bebidas' },
  { id: 'PROD017', codigo: '017', nombre: 'Agua Purificada 1L', precio: 0.75, existencia: 80, categoria: 'Bebidas' },
  { id: 'PROD018', codigo: '018', nombre: 'Galletas María', precio: 1.50, existencia: 45, categoria: 'Galletas' },
  { id: 'PROD019', codigo: '019', nombre: 'Chocorramo', precio: 1.25, existencia: 30, categoria: 'Dulces' },
  { id: 'PROD020', codigo: '020', nombre: 'Cigarros Cajetilla', precio: 5.00, existencia: 15, categoria: 'Tabaco' },
];

// Conceptos para venta libre
export const conceptosVentaLibre = [
  'Servicio de Fotocopiado',
  'Servicio de Impresión',
  'Servicio de Internet',
  'Servicio de Fax',
  'Servicio de Llamadas',
  'Empaque',
  'Delivery',
  'Otro',
];

// Conceptos para gastos
export const conceptosGasto = [
  'Compra de suministros',
  'Alquiler local',
  'Servicios básicos',
  'Mantenimiento equipos',
  'Pago de nómina',
  'Materiales de oficina',
  'Transporte',
  'Publicidad',
  'Seguro',
  'Impuestos',
  'Otro',
];
